import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import listSegment from 'assets/dashboard/listSegment.png';
import CtdDashboard from './ctdOffers';
import CtdConfigDashboard from './ctdConfigs';
import PriorityConfiguratorDashboard from './priorityconfigurator';

export const CTD_RESOURCES = {
	ctdOffers: 'ctdOffers',
	ctdConfigs: 'ctdConfigs',
	priorityConfigurator: 'priorityConfigurator'
};

export const URL = {
	[CTD_RESOURCES.ctdOffers]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/ctd/${CTD_RESOURCES.ctdOffers}`,
	[CTD_RESOURCES.ctdConfigs]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/ctd/${CTD_RESOURCES.ctdConfigs}`,
	[CTD_RESOURCES.priorityConfigurator]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/ctd/${CTD_RESOURCES.priorityConfigurator}`
};

export const LABEL = {
	[CTD_RESOURCES.ctdOffers]: 'CTD Offers',
	[CTD_RESOURCES.ctdConfigs]: 'CTD Configs',
	[CTD_RESOURCES.priorityConfigurator]: 'Priority Configurator'
};

export const COMPONENT = {
	[CTD_RESOURCES.ctdOffers]: CtdDashboard,
	[CTD_RESOURCES.ctdConfigs]: CtdConfigDashboard,
	[CTD_RESOURCES.priorityConfigurator]: PriorityConfiguratorDashboard
};

export const GET_ACTION = {
	[CTD_RESOURCES.ctdOffers]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDActiveOffers,
	[CTD_RESOURCES.ctdConfigs]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDConfigs,
	[CTD_RESOURCES.priorityConfigurator]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updatePriorityList
};

export const IMAGE_SOURCE = {
	[CTD_RESOURCES.ctdOffers]: listSegment,
	[CTD_RESOURCES.ctdConfigs]: listSegment,
	[CTD_RESOURCES.priorityConfigurator]: listSegment
};

export type Record = {
	[key: string]: string | number | boolean;
};

export type SelectedUserType = {
	email: string;
	uid: string;
	phone: string;
	userSegment: string;
	addToStatic: boolean;
};
